import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { apiProvider as ZakazkaProvider } from '@/modules/servis/zakazka/api';

import { END_LOADING, START_LOADING } from '@/main/store/listEditTypes';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { types } from './types';

export const dropdownList = {
	Brand: [],
	OrderSubtypes: [],
	Workshop: [],
};

export const edit = {
	ServiceJobId: 0 as number,
	ServiceJobNumber: null as number | null,
	ServiceJobDescription: null as string | null,
	Brand: null as string | null,
	OrderSubtypeId: null as number | null,
	WorkshopId: null as number | null,
};

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: { Brand: [], OrderSubtypes: [], Workshop: [] },
	edit,
	depTableNames: [],
	depTableSettings: {},
	localState: {},
	extraActions: {
		[types.actions.BRAND_CHANGE]: async ({ commit, state, dispatch }) => {
			commit(START_LOADING);
			const { data: orderSubType } = await ZakazkaProvider.getOrderSubType(state.edit.Brand!);
			state.edit.OrderSubtypeId = null;
			state.dropdownList.OrderSubtypes = orderSubType;
			commit(END_LOADING);
		},
	},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
